import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ContactPaymentDetailsPage.InfoPanel.Header', {
    openInXero: 'Open in Xero',
    sync: 'Sync',
    addPaymentDetails: 'Add payment details',
});
